import { Box } from "@mui/system";
import dropdownArrowIcon from "../../assets/action-items/arrow-dropdown-icon.svg";

interface DropdownBoxProps {
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
    error?: boolean;
    disabled?: boolean;
    children: React.ReactNode;
    className?: string;
  }
  
  const DropdownBox: React.FC<DropdownBoxProps> = ({ 
    onClick, 
    error, 
    disabled, 
    children, 
    className = "" 
  }) => (
    <Box
      onClick={disabled ? undefined : onClick}
      className={`dropdown-box ${className} ${disabled ? "disabled" : "editable"}`}
      sx={{
        border: error ? "1px solid red" : "1px solid #e0e0e0",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {children}
      { !disabled &&
      <img src={dropdownArrowIcon} alt="" style={{ width: "10px", height: "5px", marginLeft: "10px" }} />
      }
    </Box>
  );

  export default DropdownBox